import { decodeJwt } from './jwt';

export const storage = {
  setToken: (token) => {
    localStorage.setItem('token', token);
    
    // Decode token manually
    const decoded = decodeJwt(token);
    console.log('Decoded token:', decoded);
    
    if (decoded) {
      // Extract all user information from token
      const user = {
        username: decoded.sub || decoded.username,
        userId: decoded.userId || decoded.user_id || decoded.id,
        driverId: decoded.driverId || -1,
        vehicleId: decoded.vehicleId || -1,
        roles: decoded.roles || [],
        authorities: decoded.authorities ? (Array.isArray(decoded.authorities) ? decoded.authorities : decoded.authorities.split(',')) : [],
        permissions: decoded.permissions || [],
        exp: decoded.exp
      };
      
      console.log('User object stored:', user);
      
      // Store user directly
      localStorage.setItem('user', JSON.stringify(user));
      
      if (decoded.exp) {
        localStorage.setItem('tokenExpiration', decoded.exp.toString());
      }
    }
  },
  
  getToken: () => {
    return localStorage.getItem('token');
  },
  
  getTokenExpiration: () => {
    const exp = localStorage.getItem('tokenExpiration');
    return exp ? parseInt(exp) * 1000 : null;
  },
  
  isTokenExpired: () => {
    const expiration = storage.getTokenExpiration();
    if (!expiration) return false;
    const now = Date.now();
    const isExpired = now > expiration;
    
    if (isExpired) {
      console.log('Token expired at:', new Date(expiration).toLocaleString());
      console.log('Current time:', new Date(now).toLocaleString());
    }
    
    return isExpired;
  },
  
  getUser: () => {
    const user = localStorage.getItem('user');
    if (user) {
      try {
        return JSON.parse(user);
      } catch (e) {
        console.error('Failed to parse user', e);
        return null;
      }
    }
    return null;
  },
  
  removeUser: () => {
    localStorage.removeItem('user');
  },
  
  removeToken: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration');
  },
  
  clear: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpiration');
    localStorage.removeItem('user');
  }
};

// Also export a default for backward compatibility
export default storage;